/**
 * Features where order matters:
 */
import './supportListeners';
import './supportScriptsAndAssets';
import './supportJsEvaluation';
import './supportMorphDom';
import './supportDispatches';

/**
 * Features where order does NOT matter:
 */
import './supportDisablingFormsDuringRequest';
import './supportPropsAndModelables';
import './supportFileDownloads';
import './supportLazyLoading';
import './supportFileUploads';
import './supportQueryString';
import './supportLaravelEcho';
import './supportIsolating';
import './supportStreaming';
import './supportRedirects';
import './supportIslands';
import './supportNavigate';
import './supportEntangle';
import './supportSlots';
